import { AllDialogActions, DialogActions, DialogState, ViewAction, ViewState } from "./ViewSelectorTypes";

export const infiniteScrollReducer = (state: ViewState, action: ViewAction): ViewState => {
    switch (action.type) {
        case "inputFieldState":
            return { ...state, inputFieldState: action.payload };

        case "searchString":
            return {
                ...state,
                searchString: state.inputFieldState,
                lastLoadedPageData: null,
                data: [],
            };

        case "reset":
            return {
                data: [],
                inputFieldState: "",
                lastLoadedPageData: null,
                searchString: "",
            };

        case "loadPage":
            return {
                ...state,
                lastLoadedPageData: action.payload,
                data: [...state.data, ...action.payload.data],
            };

        default:
            return state;
    }
};

export const setNameDialogReducer = (state: DialogState, action: AllDialogActions[keyof AllDialogActions]): DialogState => {
    switch (action.type) {
        case DialogActions.RESET:
            return {
                ...state,
                initData: undefined,
                isOpenDialog: false,
                onCancel: () => {
                    // This is intentional
                },
                onClose: () => {
                    // This is intentional
                },
                onSubmit: () => Promise.resolve(),
                title: "",
            };

        case DialogActions.CONFIGURE_FORM:
            return { ...state, ...action.payload };

        default:
            return state;
    }
};
